<div *transloco="let t" class="bg-auth bg-no-repeat bg-cover h-[100vh]">
  <div
    class="absolute h-full w-full bg-black/80 flex items-center flex-col p-8"
    [class]="{ 'justify-start': isLogin(), 'justify-center': !isLogin() }"
  >
    <div class="flex items-center gap-4 mb-8">
      <img class="mt-2" src="rieaya-logo.svg" width="200" height="200" alt="" />
      <img src="police-logo.svg" width="200" height="200" alt="" />
    </div>
    @if (loginLoading() && !isLogin()) {
    <div class="flex flex-col items-center gap-3 text-white" aria-live="polite">
      <rieaya-loading-spinner
        size="2rem"
        color="#ffffff"
        trackColor="rgba(255,255,255,0.35)"
      />
      <span class="text-base font-medium">{{ t('shared/signingIn') }}</span>
    </div>
    } @else if (loginError()) {
    <div class="text-center text-white text-base font-medium" aria-live="polite">
      {{ t('shared/loginRedirecting') }}
    </div>
    } @else if (isLogin()) {
    <div
      class="w-full flex flex-col justify-center items-center md:flex-row flex-wrap gap-4 mt-4"
    >
      @for (userType of userTypes; let i = $index; track i) {
      <div
        class="rounded-lg w-[400px] border p-4 bg-white dark:bg-surface-800 transition-all hover:shadow-md cursor-pointer"
        [class.opacity-60]="roleLoading() && selectedRoleIndex() !== i"
        [class.cursor-not-allowed]="roleLoading()"
        [class.pointer-events-none]="roleLoading()"
        [attr.aria-busy]="roleLoading() && selectedRoleIndex() === i"
        role="button"
        tabindex="0"
        (click)="selectUsertype(userType, i)"
      >
        <div class="flex items-center">
          <div class="flex items-center justify-center rounded-full w-14 h-14">
            <i class="!text-[28px]" [class]="icons.shop"></i>
          </div>
          <div class="ms-2">
            <span class="block text-[#0a3b83] font-bold text-xl mb-1">
              {{
                userType.userType === LAUNDRY_MANAGER
                  ? t('laundries/laundryManager')
                  : userType.userType === LAUNDRY_STAFF
                  ? t('shared/laundryStaff')
                  : userType.userType === LAUNDRY_DELIVERY
                  ? t('shared/laundryStaffDelivery')
                  : t('shared/laundryRepresenter')
              }}
            </span>
            <div class="text-[14px] text-[#7280a8] font-normal">
              {{ t('shared/loginAs')
              }}{{
                userType.userType === LAUNDRY_MANAGER
                  ? t('laundries/laundryManager')
                  : userType.userType === LAUNDRY_STAFF
                  ? t('shared/laundryStaff')
                  : userType.userType === LAUNDRY_DELIVERY
                  ? t('shared/laundryStaffDelivery')
                  : t('shared/laundryRepresenter')
              }}
              {{ t('shared/inLaundry') }}
              {{ userType.laundry?.name }}
            </div>
          </div>
        </div>
        <div class="mt-3 min-h-5 flex items-center gap-2 text-[#0a3b83] text-sm font-medium">
          @if (roleLoading() && selectedRoleIndex() === i) {
          <rieaya-loading-spinner size="0.9rem" />
          <span>{{ t('shared/preparingAccount') }}</span>
          }
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
